<template>
  <div v-if="workers.length" class="pending-workers-panel">
    <p class="pending-workers-label">Invited - awaiting a token</p>
    <p class="pending-workers-hint">
      They will not appear on the timesheet until a token has been applied.
    </p>
    <div
      v-for="worker in workers"
      :key="worker.id"
      class="pending-worker-entry"
    >
      <span class="font-weight-medium">{{ worker.full_name }}</span>
      <span v-if="worker.trade" class="text-muted small ml-2">{{
        formatTrade(worker.trade)
      }}</span>
      <b-badge
        variant="secondary"
        pill
        class="ml-2"
        style="font-size: 0.65rem"
        title="This tradie has been invited but needs a token assigned before they can appear on the timesheet."
        >Awaiting token</b-badge
      >
    </div>
  </div>
</template>

<script>
import { formatTrade } from '@/utils/timesheetHelpers'

export default {
  name: 'SupervisorPendingWorkersPanel',
  props: {
    workers: { type: Array, required: true },
  },
  methods: {
    formatTrade,
  },
}
</script>

<style lang="scss" scoped>
.pending-workers-panel {
  margin-bottom: 1rem;
  padding: 0.85rem;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8fafc;
}

.pending-workers-label {
  margin: 0 0 0.3rem;
  color: #6b7280;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.pending-workers-hint {
  margin: 0 0 0.55rem;
  color: #94a3b8;
  font-size: 0.72rem;
}

.pending-worker-entry {
  padding: 0.2rem 0;
  color: #64748b;
}
</style>
